<template>
  <transition name="modal-fade">
    <div class="modal-backdrop z-10">
      <div
        class="modal w-1/2"
        role="dialog"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <header :id="`${context}-modal-title`" class="modal-header">
          <slot name="header">
            <strong>Questão</strong>
          </slot>
        </header>

        <section :id="`${context}-modal-description`" class="modal-body">
          <slot name="body">
            <v-md-editor
              :id="`${context}-description`"
              v-model="$attrs.value"
              left-toolbar="undo redo clear | h bold italic strikethrough quote | ul ol table hr | link code"
              right-toolbar="preview sync-scroll"
              class="form-input w-full"
              height="400px"
            />
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            <section class="flex flex-wrap">
              <button class="btn-indigo ml-auto mr-0" type="button" @click="save">
                OK
              </button>
            </section>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    context: String,
  },
  methods: {
    save() {
      this.$emit('close', this.$attrs.value)
    },
  },
}
</script>
